import React from "react";
import { Layout } from "../../components/layout";

import loadGif from "../../accets/images/gif/loader/loader.gif";

import "./Kiron.scss";

const Kiron = () => {
  return (
    <Layout
      containerStyles={
        "virtual-sports page-full-size hide-tab-navigation-footer-mobile compact-footer"
      }
      navHeader={"kiron"}
    >
      <div className="bc-loader medium full">
        <div className="bc-loader-contain">
          <img src={loadGif} alt="" />
        </div>
      </div>
    </Layout>
  );
};

export { Kiron };
